const certificationTypes = {
  Discipline: 1,
  Graduation: 2,
};

export default certificationTypes;
